<section>
    <div class="card-funcionalidade cursor-default" [ngClass]="classe" [ngStyle]="style">
      <div *ngIf="titulo" class="titulo mb-3 text-uppercase">
        {{ titulo }}
      </div>
      <ng-content></ng-content>
    </div>
  </section>
